import './loader.css'

export const PageLoader = () => {

  return (
    <div className=" w-full h-full top-0 bottom-0 left-0 right-0 fixed flex flex-col justify-center items-center bg-dayan-gray-50 z-[999]">
      <img src="/assetes/logo/logo.png" alt="logo" className=" w-[150px] " />
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}